import styled from "styled-components";

interface IButtonContainer {
  showfullName?: any;
  height?: string;
  width?: string;
}
export const ButtonContainer = styled.button<IButtonContainer>`
  ${(props) => `
    background-color: ${props.theme.colors.primaryBlue};
    color: ${props.theme.colors.white};
    font-family: ${props.theme.fontFamilies.primaryFont};
    width: ${props.showfullName ? "25rem" : props.width ?? "5rem"};
    height: ${props.height ?? "4.5rem"};
  `}
  align-self: end;
  border-radius: 5px;
  border: none;
  box-shadow: 0px 10px 20px rgba(48, 52, 92, 0.19);
  cursor: pointer;
  font-size: 1.4rem;
  justify-content: center;
  margin-top: 2rem;

  &:disabled,
  &[disabled] {
    background-color: ${({ theme }) =>
      theme.colors.primaryBlue + theme.transparencies.p20};
    cursor: default;
  }
`;
